import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { adminAPI } from '../../../../api';
import Pagination from '../../../../components/Pagination';
import Table from '../../../../components/Table';
import EditIcon from '../../../../../../../assets/images/reskin-images/icon--edit.svg';
import BinIcon from '../../../../../../../assets/images/reskin-images/icon--bin.svg';
import SVG from 'react-inlinesvg';
import RemoveModal from './components/sidebar/DeleteModal';
import useModal from '../../../../context/ModalContext';
import { useParams } from 'react-router-dom';

const columns = [
  {
    label: 'Discussion Questions',
    field: 'description',
    textAlign: 'left',
    fontWeight: 'semibold',
    width: '100%',
  },
];

const Questions = ({ searchQuery, filter, setOpenSideActionBoard }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowHovered, setRowHovered] = useState(false);
  const { setContent } = useModal();
  const { behaviorId } = useParams();

  const renderRowFn = (question) => {
    const id = question?.id;

    const actionButtons = (
      <div
        className={` absolute pin-r pin-t h-full items-center pr-2 ${
          rowHovered === id ? 'flex' : 'hidden'
        }`}
      >
        {' '}
        <button
          type="button"
          className="mr-2 p-2 bg-purple-100 rounded-lg hover:bg-purple-200"
          onClick={() =>
            setOpenSideActionBoard({
              type: 'questions',
              action: 'edit',
              ids: [id],
            })
          }
        >
          <SVG src={EditIcon} />
        </button>
        <button
          type="button"
          className="flex items-center justify-content-center bg-purple-100 hover:bg-red-lighter rounded-lg p-2"
          onClick={() => {
            setContent({
              content: (
                <RemoveModal
                  id={id}
                  refetch={refetch}
                  behaviorId={behaviorId}
                />
              ),
            });
          }}
        >
          <SVG src={BinIcon} />
        </button>
      </div>
    );

    return {
      id,
      description: (
        <div className="flex justify-between ml-4">
          <p className={`mb-4 mr-24`}>{question.description}</p>
          <div className="">{actionButtons}</div>
        </div>
      ),
    };
  };

  const { data, refetch } = useQuery(
    [
      'getAllQuestions',
      { page: currentPage, search: searchQuery, filter, behaviorId },
    ],
    adminAPI.getAllQuestions
  );

  useEffect(() => {
    refetch();
  }, [currentPage, searchQuery, filter, refetch]);

  return (
    <>
      {data?.questions && (
        <Table
          id="questions"
          data={data?.questions}
          columns={columns}
          reconstructorFn={renderRowFn}
          hasCheckbox={false}
          setRowHovered={setRowHovered}
        />
      )}
      <Pagination
        currentPage={currentPage}
        totalPage={data?.pagination?.total_pages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );
};

export default Questions;
